<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     布局模板
  | @Version:   2018-11-27  [A] 新建文件
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-container
    direction="vertical"
    class="the-layout">
    
    <el-container class="layout-container">
      <the-layout-header v-show="$route.name != 'DatavMap' "/>
      <the-layout-frame />
      <the-layout-menu />
      <the-layout-main />
    </el-container>
  </el-container>
</template>

<script>

//获取屏幕缩放比例
function getRatio() {
  var ratio = 0
  var screen = window.screen
  var ua = navigator.userAgent.toLowerCase()
  if (window.devicePixelRatio !== undefined) {
    ratio = window.devicePixelRatio
  } else if (~ua.indexOf('msie')) {
    if (screen.deviceXDPI && screen.logicalXDPI) {
      ratio = screen.deviceXDPI / screen.logicalXDPI
    }
  } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
    ratio=window.outerWidth/window.innerWidth
  }
  if (ratio) {
    ratio=Math.round(ratio*100)
  }
  return ratio
}

export default {
  name: 'TheLayout',
  components: {
    TheLayoutHeader: () => import('@/views/layout/TheLayoutHeader.vue'),
    TheLayoutFrame: () => import('@/views/layout/TheLayoutFrame.vue'),
    TheLayoutMenu: () => import('@/views/layout/TheLayoutMenu.vue'),
    TheLayoutMain: () => import('@/views/layout/TheLayoutMain.vue')
  },

  data() {
    return {
      messageInstance: null,
      isMessageShowing: false
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    if (this.messageInstance) {
      this.messageInstance.close()
      this.messageInstance = null
      this.isMessageShowing = false
    }
  },

  created() {
    this.handleResize()
  },

  methods: {
    handleResize() {
      const ratioWidth = window.screen.width / getRatio() * 100
      const ratioHeight = window.screen.height / getRatio() * 100
      if (ratioWidth < 1536) {
        if (this.isMessageShowing) {
          return
        }
        this.messageInstance = this.$message({
          duration: 0,
          message: '显示分辨率低于1600*900，应用可能无法正常显示。请调整显示器分辨率或浏览器缩放比例！',
          type: 'warning',
          showClose: true,
          onClose: () => {
            this.isMessageShowing = false
          }
        })
        this.isMessageShowing = true
      } else {
        if (this.messageInstance) {
          this.messageInstance.close()
          this.messageInstance = null
          this.isMessageShowing = false
        }
      }
    }
  }
}
</script>

<style lang="scss">
$--menu-inverse-bg: #252a2f;
.the-layout {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  .layout-container {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background-color: $--menu-inverse-bg;
  }
}
</style>
